import * as THREE from 'three'

// Exports ******************************************************************************************************
export const GetRotatedCurves = (crv, c1, c2, c3, c4) => {
  const curves = PointsToCurves(crv)
  curves[1] = RotateCurve(curves[1], c1)
  curves[2] = RotateCurve(curves[2], c2)
  curves[3] = RotateCurve(curves[3], c3)
  curves[4] = RotateCurve(curves[4], c4)
  curves.pop()
  curves.shift()
  return curves
}

export const GetRotatedCurvesRectangle = (crv, c1, c2, c3, c4) => {
  const curvesPoints = []
  const crv1 = PointsToCurveMirror2(crv[0].points)
  const crv2 = PointsToCurveMirror2(crv[1].rotations[Math.round(c1) + 12].points)
  const crv3 = PointsToCurveMirror2(crv[2].rotations[Math.round(c2) + 12].points)
  const crv4 = PointsToCurveMirror2(crv[3].rotations[Math.round(c3) + 12].points)
  const crv5 = PointsToCurveMirror2(crv[4].rotations[Math.round(c4) + 12].points)
  const crv6 = PointsToCurveMirror2(crv[5].points)
  curvesPoints.push(RotateCurve(crv1, -90))
  curvesPoints.push(RotateCurve(crv2, -90))
  curvesPoints.push(RotateCurve(crv3, -90))
  curvesPoints.push(RotateCurve(crv4, -90))
  curvesPoints.push(RotateCurve(crv5, -90))
  curvesPoints.push(RotateCurve(crv6, -90))
  curvesPoints.pop()
  curvesPoints.shift()
  return curvesPoints
}

export const GetModelPointsForRotationsRound = (crv, c1, c2, c3, c4, verticalSubdiv, horizontalSubdiv) => {
  const curves = PointsToCurves(crv)
  curves[1] = RotateCurve(curves[1], c1)
  curves[2] = RotateCurve(curves[2], c2)
  curves[3] = RotateCurve(curves[3], c3)
  curves[4] = RotateCurve(curves[4], c4)
  return GetModelPoints(curves, verticalSubdiv, horizontalSubdiv)
}

export const GetModelPointsForRotationsRectangle = (crv, c1, c2, c3, c4, verticalSubdiv, horizontalSubdiv) => {
  const curvesPoints = []
  const crv1 = PointsToCurveMirror(crv[0].points)
  const crv2 = PointsToCurveMirror(crv[1].rotations[Math.round(c1) + 12].points)
  const crv3 = PointsToCurveMirror(crv[2].rotations[Math.round(c2) + 12].points)
  const crv4 = PointsToCurveMirror(crv[3].rotations[Math.round(c3) + 12].points)
  const crv5 = PointsToCurveMirror(crv[4].rotations[Math.round(c4) + 12].points)
  const crv6 = PointsToCurveMirror(crv[5].points)
  curvesPoints.push(RotateCurve(crv1, 90))
  curvesPoints.push(RotateCurve(crv2, 90))
  curvesPoints.push(RotateCurve(crv3, 90))
  curvesPoints.push(RotateCurve(crv4, 90))
  curvesPoints.push(RotateCurve(crv5, 90))
  curvesPoints.push(RotateCurve(crv6, 90))
  const result = GetModelPoints(curvesPoints, verticalSubdiv, horizontalSubdiv)
  return result
}

function GetModelPoints (controlCurves, verticalSubdiv, horizontalSubdiv) {
  const verticalCurves = SubdivideCurves(controlCurves, verticalSubdiv)
  const horizontalCurves = GetHorizontalCurves(verticalCurves, horizontalSubdiv)
  const points = GetPointsFromSlices(horizontalCurves)
  return points
}

function GetPointsFromSlices (curves) {
  const container = []
  for (let i = 0; i < curves.length; i++) {
    const pts = curves[i].points
    container.push(pts)
  }
  return container
}

export const CreateShapeFromPoints = (points, thickness, pipeSides) => {
  const srf = PointsToPipe(points, thickness, pipeSides)
  return srf
}

export const CreateShapeFromPointsAtOnce = function * (points, thickness, pipeSides, posA, posB, posC, forceA, forceB, forceC, maxDist, extrusion) {
  const pts = []
  const maxDistA = forceA * maxDist
  const maxDistB = forceB * maxDist
  const maxDistC = forceC * maxDist
  let factor = 1
  for (let i = 0; i < points.length - 1; i++) {
    for (let j = 0; j < points[i].length; j++) {
      let pt = points[i][j]
      if (i === 0 && j === 0) {
        pt = new THREE.Vector3(pt.x, points[1][0].y, pt.z)
        pts.push(pt)
        continue
      }
      if (j % 2 === 0) {
        let pr = j - 1
        if (pr < 0) {
          pr = points[i].length - 1
        }
        let ne = j + 1
        if (ne > points[i].length - 1) {
          ne = 0
        }
        const prevPt = points[i][pr]
        const nextPt = points[i][ne]
        let upperPt
        if (i + 1 < points.length) {
          upperPt = points[i + 1][j]
        }
        if (upperPt) {
          pt = new THREE.Vector3(pt.x + (upperPt.x - pt.x) * j / (points[i].length - 1), pt.y, pt.z + (upperPt.z - pt.z) * j / (points[i].length - 1))
        }
        pt = OffsetPoint(pt, prevPt, nextPt, factor, posA, posB, posC, maxDistA, maxDistB, maxDistC, extrusion, i / points.length * 2, i, points.length - 2)
        factor = factor === 1 ? -1 : 1
      } else {
        let upperPt
        if (i + 1 < points.length) {
          upperPt = points[i + 1][j]
        }
        if (upperPt) {
          pt = new THREE.Vector3(pt.x + (upperPt.x - pt.x) * j / (points[i].length - 1), pt.y, pt.z + (upperPt.z - pt.z) * j / (points[i].length - 1))
        }
      }
      if (i === points.length - 2) {
        pts.push(new THREE.Vector3(pt.x, pt.y, pt.z))
      } else {
        pts.push(new THREE.Vector3(pt.x, pt.y + (thickness * j / (points[i].length - 1)), pt.z))
      }
    }
    factor = factor === 1 ? -1 : 1
    if (i > 0 && i % 8 === 0) {
      yield
    }
  }
  const crv = new THREE.CatmullRomCurve3(
    pts,
    false,
    'centripetal'
  )
  var geometry = new THREE.TubeBufferGeometry(crv, crv.points.length * 3, thickness, pipeSides, false)
  var mesh = new THREE.Mesh(geometry)
  return mesh
}

function PointsToPipe (points, thickness, pipeSides) {
  const crv = new THREE.CatmullRomCurve3(
    points,
    false,
    'centripetal'
  )
  var geometry = new THREE.TubeBufferGeometry(crv, crv.points.length, thickness, pipeSides, false)
  var mesh = new THREE.Mesh(geometry)
  // var mesh = new THREE.Mesh(geometry.toNonIndexed())
  return mesh
}

function OffsetPoint (point, prev, next, factor, posA, posB, posC, maxDistA, maxDistB, maxDistC, extrusion, mult, layer, maxlayers) {
  const pointVec = new THREE.Vector3(point.x, point.y, point.z)
  const distA = new THREE.Vector3(posA.x, posA.y, posA.z).distanceTo(pointVec)
  const distB = new THREE.Vector3(posB.x, posB.y, posB.z).distanceTo(pointVec)
  const distC = new THREE.Vector3(posC.x, posC.y, posC.z).distanceTo(pointVec)
  const pool = []
  if (distA < maxDistA) {
    pool.push(distA / maxDistA)
  }
  if (distB < maxDistB) {
    pool.push(distB / maxDistB)
  }
  if (distC < maxDistC) {
    pool.push(distC / maxDistC)
  }
  if (pool.length > 0) {
    let min = Math.min(...pool)
    min = (1 - min) * 0.01
    min = Math.min(Math.max(min, 0.0003), extrusion * mult)
    const prevVec = new THREE.Vector3(prev.x, 0, prev.z)
    const nextVec = new THREE.Vector3(next.x, 0, next.z)
    const diffVec = nextVec.sub(prevVec).normalize()
    diffVec.applyAxisAngle(new THREE.Vector3(0, 1, 0), Deg2Rad(90))
    if (diffVec) {
      let reduceFactor = 1
      if (layer >= maxlayers - 3) {
        reduceFactor = (1 - ((layer - (maxlayers - 3)) / 3)) * 0.5
      }
      if (layer < 3) {
        reduceFactor = layer / 3
      }
      const layerFactor = 0.5 + (layer / maxlayers) * 0.5
      return pointVec.clone().add(new THREE.Vector3(diffVec.x * factor * min * reduceFactor * layerFactor, 0, diffVec.z * factor * min * reduceFactor * layerFactor))
    } else {
      return pointVec
    }
  } else {
    return pointVec
  }
}

// Create curves from json points data
// Input: points list [[x, y, z], ...], [], ....
// Output: curves (CatmullRomCurve3)
export const PointsToCurves = (curvesData) => {
  const curves = []
  for (let i = 0; i < curvesData.length; i++) {
    curves.push(PointsToCurve(curvesData[i].points))
  }
  return curves
}

function PointsToCurve (curvePoints) {
  const pts = []
  curvePoints.forEach(point => {
    const pt = new THREE.Vector3(point[0], point[1], point[2])
    pts.push(pt)
  })
  const curve = new THREE.CatmullRomCurve3(
    pts,
    true
  )
  return curve
}

function PointsToCurveMirror (curvePoints) {
  const pts = []
  curvePoints.forEach(point => {
    const pt = new THREE.Vector3(-point[0], point[1], point[2])
    pts.push(pt)
  })
  const curve = new THREE.CatmullRomCurve3(
    pts,
    true
  )
  return curve
}

function PointsToCurveMirror2 (curvePoints) {
  const pts = []
  curvePoints.forEach(point => {
    const pt = new THREE.Vector3(point[0], point[1], -point[2])
    pts.push(pt)
  })
  const curve = new THREE.CatmullRomCurve3(
    pts,
    true
  )
  return curve
}

// Rotate a curve by n degrees
// Input: curve (CatmullRomCurve3)
// Output: rotated curve (CatmullRomCurve3)
export const RotateCurve = (curve, angle) => {
  const axis = new THREE.Vector3(0, 1, 0)
  const points = []
  const angleDeg = Deg2Rad(angle)
  for (let i = 0; i < curve.points.length; i++) {
    points.push(curve.points[i].applyAxisAngle(axis, angleDeg))
  }
  const crv = new THREE.CatmullRomCurve3(
    points,
    true
  )
  return crv
}

// Create a line geometry to be added to the scene
// Input: curve (CatmullRomCurve3), (color), samples (number)
// Output: (Line)
export const CreateCurve = (curve, mat, samples, force) => {
  const points = curve.getPoints(samples)
  const pointsResult = []
  for (let i = 0; i < points.length; i++) {
    let prev
    if (i > 0) {
      prev = points[i - 1]
    } else {
      continue
    }
    const diffVec = points[i].clone().sub(prev.clone()).normalize()
    diffVec.applyAxisAngle(new THREE.Vector3(0, 1, 0), Deg2Rad(90))
    pointsResult.push(points[i].clone().addScaledVector(diffVec, force))
  }
  pointsResult.push(pointsResult[0])
  const geometry = new THREE.BufferGeometry().setFromPoints(pointsResult)
  const material = mat
  return new THREE.Line(geometry, material)
}

// Converts UV coordinates to world XYZ coordinates.
// Input: u (0-_subU), v (0-_subV)
// Output: Vector3
export const UvToXYZ = (points, u, v) => {
  const mappedU = Math.floor(u * points.length)
  const mappedV = Math.floor(v * points[mappedU].length)
  return points[mappedU][mappedV]
}

// Converts XYZ coordinates to UV
// Input: x (number), y (number), z (number)
// Output: u (0-_subU), v (0-_subV)
export const XYZToUV = (points, x, y, z) => {
  const height = points[points.length - 1][0].y
  const layer = Math.floor((y / height) * (points.length - 1))
  let minDist = 1000
  let indexI = 0
  if (!points[layer] || points.length <= layer) return { u: 0, v: 0 }
  for (let i = 0; i < points[layer].length; i++) {
    if (points[layer][i]) {
      const dist = new THREE.Vector3(x, y, z).distanceTo(points[layer][i])
      if (dist < minDist) {
        minDist = dist
        indexI = i
      }
    }
  }
  const u = layer / points.length
  const v = indexI / points[0].length
  return { u: u, v: v }
}

export const GetPts2DData = (camera, object, ptA, ptB, ptC) => {
  const width = window.innerWidth
  const height = window.innerHeight
  const widthHalf = width / 2
  const heightHalf = height / 2
  const vecA = new THREE.Vector3(ptA.x, ptA.y, ptA.z)
  const vecB = new THREE.Vector3(ptB.x, ptB.y, ptB.z)
  const vecC = new THREE.Vector3(ptC.x, ptC.y, ptC.z)
  const a = vecA.clone().project(camera)
  const ax = (a.x * widthHalf) + widthHalf
  const ay = -(a.y * heightHalf) + heightHalf
  const b = vecB.clone().project(camera)
  const bx = (b.x * widthHalf) + widthHalf
  const by = -(b.y * heightHalf) + heightHalf
  const c = vecC.clone().project(camera)
  const cx = (c.x * widthHalf) + widthHalf
  const cy = -(c.y * heightHalf) + heightHalf
  const aVisible = GetPointVisibility(vecA, camera.position, object)
  const bVisible = GetPointVisibility(vecB, camera.position, object)
  const cVisible = GetPointVisibility(vecC, camera.position, object)
  return {
    A: { x: ax, y: ay, visible: aVisible },
    B: { x: bx, y: by, visible: bVisible },
    C: { x: cx, y: cy, visible: cVisible }
  }
}

function GetPointVisibility (position, camera, object) {
  const vec = (camera.clone().sub(position.clone())).normalize()
  const raycaster = new THREE.Raycaster(position, vec)
  const intersects = raycaster.intersectObjects([object])
  return intersects.length < 2
}

export const BuildCollider = (points) => {
  const geometry = new THREE.Geometry()
  const vertices = []
  const v = 1
  for (let i = 0; i < points.length; i += 1) {
    for (let j = 0; j < points[i].length; j += v) {
      vertices.push(points[i][j])
    }
  }
  for (let i = 0; i < points[points.length - 1].length; i += v) {
    vertices.push(points[points.length - 1][i])
  }
  geometry.vertices = vertices
  const sides = Math.floor(points[0].length) + 1
  for (let i = 0; i < geometry.vertices.length - sides; i++) {
    let next = i + 1
    if (next % sides === 0) {
      next = (next / sides - 1) * sides
    }
    const face = new THREE.Face3(i, i + sides, next)
    const backface = new THREE.Face3(i, next, i + sides)
    geometry.faces.push(face)
    geometry.faces.push(backface)
    if (i + sides + 1 < geometry.vertices.length) {
      let up = i + sides + 1
      if (up % sides === 0) {
        up = (up / sides - 1) * sides
      }
      const face2 = new THREE.Face3(next, i + sides, up)
      const backface2 = new THREE.Face3(next, up, i + sides)
      geometry.faces.push(face2)
      geometry.faces.push(backface2)
    }
  }
  const mesh = new THREE.Mesh(geometry)
  mesh.visible = false
  mesh.scale.set(0.99, 1, 0.99)
  return mesh
}

// Internal ******************************************************************************************************

// Subdivise control curves and interpolate points between them.
// Input : control curves (CatmullRomCurve3), vertical subdivisions (number).
// Output : interpolated vertical curves (CatmullRomCurve3).
function SubdivideCurves (curves, subdivX) {
  const points = []
  curves.forEach(curve => {
    points.push(curve.getSpacedPoints(subdivX))
  })
  const verticalCurves = []
  for (let i = 0; i < subdivX; i++) {
    const ctrlpt = []
    points.forEach(curve => {
      ctrlpt.push(curve[i])
    })
    verticalCurves.push(new THREE.CatmullRomCurve3(ctrlpt))
  }
  return verticalCurves
}

// Using the SubdiviceCurves result, this function basically interpolate the control curves in order to generate a smoothed mesh later on.
// Input : vertical curves (CatmullRomCurve3), horizontal subdivisions (number).
// Output : horizontal curves ready to be lofted (CatmullRomCurve3).
function GetHorizontalCurves (curves, divisions) {
  const lowest = curves[0].getPoint(0).y
  const highest = curves[0].getPoint(1).y
  const height = highest - lowest
  const spacing = height / divisions
  const horizontalCurves = []
  for (let i = lowest; i < highest; i += spacing) {
    const points = []
    curves.forEach(crv => {
      const p = GetCP(crv, i, height, 1)
      points.push(p)
    })
    horizontalCurves.push(new THREE.CatmullRomCurve3(points, true))
  }
  // highest :
  const points = []
  curves.forEach(crv => {
    const p = GetCP(crv, highest, height, 1)
    points.push(p)
  })
  horizontalCurves.push(new THREE.CatmullRomCurve3(points, true))
  return horizontalCurves
}

// Project a point on a curve along the XZ plane (iterative approximation).
// Input : curve (CatmullRomCurve3), desired height (number), surface total height (number), iterations (number).
// Output : projected point (Vector3)
function GetCP (curve, height, totalHeight, iterations) {
  let i = 0
  let t = height / totalHeight
  let p = null
  while (i < iterations) {
    p = curve.getPoint(t)
    t = (height - p.y) / totalHeight
    i++
  }
  return p
}

// Converts degrees to radians.
function Deg2Rad (degrees) {
  const pi = Math.PI
  return degrees * (pi / 180)
}

function Rad2Deg (radians) {
  var pi = Math.PI
  return radians * (180 / pi)
}

function mod (n, m) {
  return ((n % m) + m) % m
}
